<template>
  <div class="container">
    <div class="row mb-5">
      <div v-for="table of tables" :key="'table' + table.id" class="col-md-4">
        <div class="card text-center" :class="{'bg-primary': activeTable === table, 'text-white': activeTable === table}" @click="selectTable(table)">
          <div class="card-body">
            {{ table.name }}
          </div>
        </div>
      </div>
    </div>
    <UITable :data="data" />
  </div>
</template>

<script>
  import UITable from './components/UITable.vue'
  import axios from 'axios'

  export default {
    name: 'Orders',
    data: function () {
      return {
        data: [],
        activeTable: null,
        tables: [],
        ids: [],
        status: 'loading'
      }
    },
    components: {
      UITable,
    },
    mounted: function() {
      const elem = document.getElementById('sms-shop-app-tables')
      if (elem) {
        const ids = JSON.parse(elem.textContent)
        this.ids = ids
      }
      
      this.reloadNav();
    },
    methods: {
      reloadNav() {
        axios.get(process.env.VUE_APP_API_URL + '/tables', {
          params: {
            ids: this.ids,
          },
        }).then(response => {
          this.tables = response.data
          this.activeTable = this.tables[0]
          this.reloadData();
        })
        
      },
      reloadData() {
        axios.get(process.env.VUE_APP_API_URL + '/tables/' + this.activeTable.id).then(response => {
          this.data = response.data
        })
      },
      selectTable(table) {
        this.activeTable = table
        this.reloadData()
      }
    }
  }
</script>